const events = ['fileProgress', 'fileSuccess', 'fileComplete', 'fileError', 'fileRetry']

export default events



// WEBPACK FOOTER //
// ./src/common/file-events.js